// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

export const databaseSlice = createSlice({
  name: 'database',
  initialState: {
    selectedDb: {}
  },
  reducers: {
    setSelectedDb(state, action) {
      state.selectedDb[action.payload.key] = action.payload.value
    }
  }
})

export const { setSelectedDb } = databaseSlice.actions

export default databaseSlice.reducer
